module.exports = __webpack_public_path__ + "img/project_e1.baed619f.jpg";